<template>
  <div>
    <container-headline
      headline="Einverständnisse"
      :col="6"
    ></container-headline>
    <div class="row mb-3">
      <div class="col-xl-12 block br-t-l-0">
        <div class="eingabe-panel-kopf p-3">
          <div class="row">
            <div class="form-check col-xl-4" style="padding-left: 36px">
              <input
                type="checkbox"
                v-model="person.einverstaendnisse.newsletter"
                class="form-check-input"
                :disabled="!editable"
              />
              <label>{{ $t("global.newsletter") }}</label>
            </div>
            <div class="form-check col-xl-4" style="padding-left: 36px">
              <input
                type="checkbox"
                v-model="person.einverstaendnisse.bestaetigungAngaben"
                class="form-check-input"
                :disabled="!editable"
              />
              <label>{{ $t("global.confirmationdata") }}</label>
            </div>
            <div class="form-check col-xl-4" style="padding-left: 36px">
              <input
                type="checkbox"
                v-model="person.einverstaendnisse.weitergabeDaten"
                class="form-check-input"
                :disabled="!editable"
              />
              <label>{{ $t("global.consentinformation") }}</label>
            </div>
          </div>
          <div class="row">
            <div class="form-check col-xl-4" style="padding-left: 36px">
              <input
                type="checkbox"
                v-model="person.einverstaendnisse.einverstaendnisTeuilnamebedingungen"
                class="form-check-input"
                :disabled="!editable"
              />
              <label>{{ $t("global.termsandconditions") }}</label>
            </div>
            <div class="form-check col-xl-4" style="padding-left: 36px">
              <input
                type="checkbox"
                v-model="person.einverstaendnisse.einverstaendnisDatenschutzbestimmungen"
                class="form-check-input"
                :disabled="!editable"
              />
              <label>{{ $t("global.privacypolicy") }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerHeadline from "@/components/ContainerHeadline";

export default {
  name: "GeschaeftspartnerEinverstaendnisseNewViva",
  components: {
    ContainerHeadline,
  },
  mixins: [],
  props: {
    person: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
};
</script>
